import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';

import { Utilities_OperationService } from './Utilities.operation.service';
import { Notifications_OperationService } from './Notifications.operation.service';
import { Addresses_OperationService } from './Addresses.operation.service';
import { PurchaseOrders_OperationService } from './PurchaseOrders.operation.service';
import { Materials_OperationService } from './Materials.operation.service';
import { Invoices_OperationService } from './Invoices.operation.service';
import { SalesOrders_OperationService } from './SalesOrders.operation.service';
import { Carriers_OperationService } from './Carriers.operation.service';
import { Inventory_OperationService } from './Inventory.operation.service';
import { FootprintApiManager_OperationService } from './FootprintApiManager.operation.service';


@Injectable({ providedIn: 'root' })
export class app_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
  ) {
    this.Utilities = this.injector.get(Utilities_OperationService);
    this.Notifications = this.injector.get(Notifications_OperationService);
    this.Addresses = this.injector.get(Addresses_OperationService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_OperationService);
    this.Materials = this.injector.get(Materials_OperationService);
    this.Invoices = this.injector.get(Invoices_OperationService);
    this.SalesOrders = this.injector.get(SalesOrders_OperationService);
    this.Carriers = this.injector.get(Carriers_OperationService);
    this.Inventory = this.injector.get(Inventory_OperationService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_OperationService);
  }

    public Utilities: Utilities_OperationService;
    public Notifications: Notifications_OperationService;
    public Addresses: Addresses_OperationService;
    public PurchaseOrders: PurchaseOrders_OperationService;
    public Materials: Materials_OperationService;
    public Invoices: Invoices_OperationService;
    public SalesOrders: SalesOrders_OperationService;
    public Carriers: Carriers_OperationService;
    public Inventory: Inventory_OperationService;
    public FootprintApiManager: FootprintApiManager_OperationService;
  public app: app_OperationService = this;


  private isAuthorized(operationName: string): Promise<boolean> {
    return this.$utils.http.post(`${environment.backendUrl}api/app/operations/${operationName}/isauthorized`, null);
  }
}
